import {WaiverItem} from "@/types/event/WaiverItem";

export const getWaiverDetails = async (ticketId: string): Promise<{
    completed_items: string[],
    waiver_items: WaiverItem[]
}> => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/tickets/get-waiver-details/${ticketId}`);
    if (!response.ok) {
        throw new Error("Failed to fetch event details");
    }
    return response.json();
};